export const i18n = (() => {
    let _t = {};
    return {
        async load(locale = 'fr') {
            try {
                const res = await fetch(`/i18n/${locale}.json`);
                _t = await res.json();
            } catch(e) {
                console.warn(`i18n: impossible de charger ${locale}.json`, e);
            }
            this.apply();
        },
        t(key, params = {}) {
            let str = _t[key] ?? key;
            if (typeof str !== 'string') return key;
            for (const [k, v] of Object.entries(params)) {
                str = str.replaceAll(`{{${k}}}`, v);
            }
            return str;
        },
        tArray(key) {
            const val = _t[key];
            return Array.isArray(val) ? val : [];
        },
        apply() {
            document.querySelectorAll('[data-i18n]').forEach(el => {
                el.textContent = this.t(el.dataset.i18n);
            });
            document.querySelectorAll('[data-i18n-html]').forEach(el => {
                el.innerHTML = this.t(el.dataset.i18nHtml);
            });
            document.querySelectorAll('[data-i18n-placeholder]').forEach(el => {
                el.placeholder = this.t(el.dataset.i18nPlaceholder);
            });
            document.querySelectorAll('[data-i18n-title]').forEach(el => {
                el.title = this.t(el.dataset.i18nTitle);
            });
            window.updateLangPickers?.();
            document.dispatchEvent(new CustomEvent('i18n:ready'));
        }
    };
})();

export const t = (key, params) => i18n.t(key, params);
